// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2993) return "static/chunks/2993.e048e5e71f1306be.js";
	if (chunkId === 9634) return "static/chunks/9634.6d49cc4316fcf4c4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"19":"1f939d587444f697","5608":"7feca5847aff70ad","8765":"73b335754a094ef9","9334":"3f20346fced2ee02"}[chunkId] + ".js";
};